import playerMutations from "./mutations.js";
import playerGetters from "./getters.js";

export default {
    namespaced: true,
    state() {
        return {
           currentMiniPlayer:null,
        };
    },
    mutations: playerMutations,
    getters: playerGetters,
};